import { Button, Drawer } from '@navi/web-ui/lib/primitives';
import { AgTable, Pagination } from '@navi/web-ui/lib/components';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { fetchCallLimitHistory } from '../../CallLimitActions';
import { DropDownPosition } from '../../types';
import Loader from '@cp/src/components/Loader/Loader';
import { GenericObject } from '@cp/src/types/CommonConstans';
import { useColumnDefs } from './ColumnDefs';
import HistoryIcon from '@cp/src/assets/icons/HistoryIcon';
import dayjs from 'dayjs';
import { DateTimeFormat } from '@cp/src/components/DateTimePicker/constants';

const CallLimitHistory = () => {
  const dispatch = useDispatch();
  const { columnDefs } = useColumnDefs();
  const [showHistoryDrawer, setShowHistoryDrawer] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const data = useSelector((store: RootState) => store.callLimit?.data);
  const pages = useSelector((store: RootState) => store.callLimit?.pages);
  const [rowData, setRowData] = useState<Array<GenericObject>>([]);

  const transformRowData = () => {
    if (!data || !Array.isArray(data)) return [];
    return data.map((item: GenericObject) => {
      const { startTime } = item;
      if (!startTime) return {};
      const dateString = dayjs(startTime).utc(startTime).local().format(DateTimeFormat.DATE_TIME);
      const totalLans = item.successCount + item.failureCount;
      return {
        totalLans,
        uploaded: item.successCount,
        failed: item.failureCount,
        uploadDateTime: dateString,
        status: item.uploadStatus,
        file: item.referenceId,
        failureReportExists: item.failureCount > 0
      };
    });
  };

  useEffect(() => {
    if (data) {
      setRowData([...transformRowData()]);
    }
  }, [data]);

  const handleOnPageChange = (pageNumber: number) => {
    setPageNumber(pageNumber);
  };

  const handleOnPageSizeChange = (pageSize: number) => {
    setPageSize(pageSize);
    setPageNumber(1);
  };

  useEffect(() => {
    if (!showHistoryDrawer) {
      setPageNumber(1);
      setPageSize(10);
      return;
    }
    setIsDataLoading(true);
    dispatch(
      fetchCallLimitHistory(pageNumber - 1, pageSize, () => {
        setIsDataLoading(false);
      })
    );
  }, [pageNumber, pageSize, showHistoryDrawer]);

  return (
    <>
      <Button
        variant="text"
        size="medium"
        startAdornment={<HistoryIcon />}
        onClick={() => setShowHistoryDrawer(true)}
      >
        History
      </Button>
      <Drawer
        headerText="Call limit history"
        open={showHistoryDrawer}
        onClose={() => setShowHistoryDrawer(false)}
        usePadding={false}
        disableOutsideClick={false}
        className="!w-[750px]"
      >
        <AgTable
          defaultColDef={{
            suppressMovable: true,
            wrapText: true,
            autoHeight: true
          }}
          className="callLimitHistoryTable"
          rowData={rowData || []}
          columnDefs={columnDefs}
          headerHeight={28}
          rowHeight={43}
          theme={'alpine'}
          sizeColumnsToFit={true}
          getAgRowStyle={() => {
            return { color: 'var(--grayscale-2)' };
          }}
          paginationWrapperClasses={'paginationWrapperClasses'}
          PaginationComponent={
            <Pagination
              totalCount={pages?.totalElements || 0}
              onPageChange={handleOnPageChange}
              currentPage={pageNumber}
              onPageSizeChange={handleOnPageSizeChange}
              pageSize={pageSize}
              pageNumberDropDownPosition={DropDownPosition.TOP}
            />
          }
        />
        <Loader show={isDataLoading} className={'overlay'} animate={false} />
      </Drawer>
    </>
  );
};

export default CallLimitHistory;
